<template >
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-modal
  v-model="modal"
  :title="banderaFlujo != 7 ? 'Recolección' : 'Recolección a clínica'"
  centered
  size="lg">
    <div>
      <p style="font-weight: 600;">¿Cómo se realizará el envío del paquete?</p>
      <b-form v-on:submit.prevent="aceptarSolicitud">
        <b-row>
          <b-col>
            <b-form-group class="text-center">
              <b-form-radio-group
                  v-model="tipoRecoleccion"
                  :options="listaTipoRecoleccion"
                  value-field="idRecoleccionLaboratorio"
                  text-field="descripcion"
                  :state="tipoRecoleccion != null"
                  required
              ></b-form-radio-group>
              <b-form-invalid-feedback :state="tipoRecoleccion != null">
                Selecciona una opción
              </b-form-invalid-feedback>
            </b-form-group>

            <div v-if="tipoRecoleccion === 2">
              <label>Paqueteria: *</label>
              <v-select
                  v-model.trim="paqueteria"
                  label="paqueteria"
                  :options="paqueterias"
                  @input="abrirLiga($event)"
              >
              </v-select>

            </div>
            <div v-if="tipoRecoleccion === 2">
              <label>Número o código de guía: *</label>
              <b-form-input
                  v-model.trim="numeroGuia"
                  placeholder="Número o código"
                  :state="numeroGuia != ''"
                  required
              >
              </b-form-input>
              <b-form-invalid-feedback :state="numeroGuia != ''">
                debe colocar la guía
              </b-form-invalid-feedback>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div slot="modal-footer">
      <b-button style="margin-right: 40px" variant="outline-primary" :disabled="loaderAcciones" @click="aceptarSolicitud()">
        <span v-if="!loaderAcciones">Guardar</span>
        <span v-if="loaderAcciones">
                      <b-spinner small></b-spinner>
                  Cargando...
                  </span>
      </b-button>
      <b-button variant="outline-danger" :disabled="loaderAcciones" @click="modal=false">Cancelar</b-button>
    </div>
</b-modal>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";
/* import Header from "../../components/Header"; */
import {CatalogosService} from "../../apiServices/catalogos/CatalogosService";
/* import BotonCancelar from "../../components/BotonCancelar"; */

export default {
  name: "Recoleccion",
  components: {},
  props: {
    parametros: null,
    banderaFlujo: null,

    idTrabajoEtapaSeleccionado: {
      type: Number,

    },
    idTrabajoMaster: {
      type: Number,

    },
    idEtapa: {
      type: Number,

    },
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    modal: true,
    catalogoServicio: new CatalogosService(),
    listaTipoRecoleccion: [],
    tipoRecoleccion: null,
    idTrabajoLaboratorio: null,
    numeroGuia: "",
    cargando: true,
    enviando: false,
    idSolicitud: null,
    idEtapa: null,
    paqueterias:[],
    paqueteria: null
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idSolicitud = this.$route.params.idSolicitud
    this.idEtapa= this.$route.params.idEtapa
    this.traerTipoRecoleccion();
    this.obtenerPaqueterias();
  },
  methods: {
    obtenerPaqueterias(){
      this.catalogoServicio.obtenerPaquetrias()
          .then(response => {
            this.paqueterias = response.data
          })
    },
    abrirLiga(e){
      window.open(e.url, '_blank');
    },
    traerTipoRecoleccion() {
      const urlRecoleccion =
          this.$api + "laboratorio/obtener/recoleccionLaboratorio";
      this.$http
          .get(urlRecoleccion)
          .then((response) => {
            if (response.data.data) {
              this.listaTipoRecoleccion = response.data.data;
              this.cargando = false;
            }
          })
          .catch((err) => {
            this.errorMensaje(err);
            this.cargando = false;
          });
    },
    aceptarSolicitud() {
      this.enviando = true;
      const urlEnviarRecoleccion =
          this.$api + "laboratorio/actualizar/solicitudRecoleccion";
      this.$http
          .put(urlEnviarRecoleccion, this.traerDatos())
          .then((response) => {
            if (response.status === 200) {
              this.$swal({
                icon: "success",
                text: "Se envió la información correctamente",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
              });
              this.enviando = false;
              location.reload();
            }
          })
          .catch((err) => {
            this.errorEnvio(err);
            this.enviando = false;
          });
    },
    traerDatos() {
      return {
        idRecoleccionLaboratorio: this.tipoRecoleccion,
        numeroGuia: this.numeroGuia,
        idTrabajoEtapaActual: this.idTrabajoEtapaSeleccionado,
        idTrabajoMaster: this.idTrabajoMaster,
        siguienteEtapa: this.idEtapa + 1,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
        finCiclo: false,
        idSolicitud: this.parametros[0].idSolicitud,
        idEtapa: this.parametros[0].idEtapa
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>
